import React from 'react';
import { Navigate, type RouteObject } from 'react-router-dom';

import { CustomizerLayout } from '../../layouts/CustomizerLayout';
import { CUSTOMIZER_BASE } from './store/customizer';
import { CustomizerIndex } from './CustomizerIndex';
import CustomizerRoot from './index';
import CountryStep from './steps/country';
import BrandStep from './steps/brand';
import LogoStep from './steps/logo';
import DeployStep from './steps/deploy';

/**
 * Route tree for the customizer wizard ("Take your website live").
 *
 * Like the configurator-v3 wizard this is a LAYOUT route: `CustomizerRoot`
 * provides the shared `CustomizerProvider` + page shell and renders the active
 * step via `<Outlet/>`, so wizard state persists across step navigation. It is
 * wrapped in `CustomizerLayout` (app side rail + auth gate, the wizard's own
 * header) rather than the full-bleed bridge the configurator uses.
 */
export const customizerRoute: RouteObject = {
  path: CUSTOMIZER_BASE,
  element: (
    <CustomizerLayout>
      <CustomizerRoot />
    </CustomizerLayout>
  ),
  children: [
    { index: true, element: <CustomizerIndex /> },
    { path: 'country', element: <CountryStep /> },
    { path: 'brand', element: <BrandStep /> },
    { path: 'logo', element: <LogoStep /> },
    { path: 'deploy', element: <DeployStep /> },
    { path: '*', element: <Navigate to="country" replace /> },
  ],
};

export default customizerRoute;